import { SurgicalOrderRepository } from 'repository/repositories/surgical-order/surgical-order-repository'
import { EditFinalizeSurgicalOrder } from 'domain/usecases/surgical-order/edit-finalize-surgical-order'

export class RemoteEditFinalizeSurgicalOrder
  implements EditFinalizeSurgicalOrder
{
  constructor(
    private readonly surgicalOrderRepository: SurgicalOrderRepository
  ) {}

  finish(params: EditFinalizeSurgicalOrder.Params) {
    return this.surgicalOrderRepository.editFinalizeSurgicalOrder(params)
  }
}
